<template>
	<v-container fill-height fluid class="pa-0">
		<!-- <Editar />
		<Excluir />-->
		<v-dialog v-model="imprimirAtendimento" persistent max-width="800" scrollable>
			<v-card :loading="loading">
				<v-toolbar flat dense color="primary"></v-toolbar>
				<v-divider></v-divider>
				<v-card-text class="text-center">
					<iframe type="application/pdf" src="" ref="relPdf">
						<!-- <Relatorio :atendimento="atendimento" ref="relatorio"/> -->
					</iframe>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<!-- <v-btn text @click="imprimir()" color="primary">Download</v-btn> -->
					<v-btn text color="primary" @click.stop="fechar()">Fechar</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<Novo :mostrar="abrirEdicao" :registroAtendimento="atendimento" @finalizarAtendimento="finalizarAtendimento()" @atualizarAtendimento="atualizarAtendimento($event)" @fecharAtendimento="fecharAtendimento()"/>
		<v-row class="ma-0">
			<v-col cols="12" class="pa-0">
				<v-card tile :height="this.$store.getters.alturaContent" cols="12" :loading="loading">
					<v-card-title>
						<v-row>
							<v-col cols="4" offset="7">
								<v-text-field dense
									v-model="search"
									append-icon="mdi-magnify"
									label="Pesquisa"
									single-line
									hide-details
								></v-text-field>
							</v-col>
							<v-col cols="1">
								<!-- <v-btn @click="cadastrarNovaFicha" color="primary" small>Novo</v-btn> -->
							</v-col>
						</v-row>
					</v-card-title>
					<v-card-text>
						<v-data-table :page.sync="pagina" hide-default-footer :height="this.$store.getters.alturaContent - 170" locale="pt-BR" dense fixed-header class="table-item"
                        :search="search" :items="fichas" :headers="fields" :items-per-page="itensPorPagina">
							<template v-slot:item.data_atendimento="{ item }">
								{{mostrarData(item.data_atendimento)}}
							</template>
							<template v-slot:item.action="{ item }">
								<v-btn icon class="mx-1" color="primary" @click="gerarPdf(item)">
									<v-icon>mdi-file-pdf</v-icon>
								</v-btn>
								<v-btn icon class="mx-1" color="primary" @click="editar(item)">
									<v-icon>mdi-lead-pencil</v-icon>
								</v-btn>
							</template>
						</v-data-table>
                        <v-row>
                            <v-col cols=12>
                                <v-pagination :length="totalPaginas" total-visible="7" v-model="pagina">
                                </v-pagination>
                            </v-col>
                        </v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>

	import { baseApiUrl, showError } from "@/config/global"
	import axios from 'axios'
	// import Editar from '@/components/atendimento/pessoas/Editar'
	// import Excluir from '@/components/atendimento/pessoas/Excluir'
	import Novo from '@/components/atendimento/fichas/Novo'
	import metodos from '@/mixins/metodos.js'
	// import Relatorio from "@/components/relatorios/Atendimento"
	//import html2canvas from 'html2canvas'
	import jsPDF from 'jspdf'
	import 'jspdf-autotable'

	export default{
		mixins:[metodos],
		components:{
            //Editar,
            //Excluir,
			Novo,
			//Relatorio

            },
		computed:{

		},
		data(){
			return {
				linkPdf: null,
				mostrarRelatorio: true,
				imprimirAtendimento: false,
                pagina: 1,
                totalPaginas: 1,
                itensPorPagina: 8,
				search: '',
				abrirEdicao: false,
				abrirNovaFicha: false,
				abrirExclusaoFicha: false,
				fichas: [],
				ficha: {},
				fields: [
					{value: 'id', text: 'Código', align: 'left'},
					{value: 'nome_atendido', text: 'Nome', align: 'left'},
                    {value: 'data_atendimento', text: 'Data Atendimento', align: 'left'},
                    {value: 'hora_atendimento' , text: 'Horario', align: 'left'},
					{value: 'nome_responsavel', text: 'Responsavel', align: 'left'},
					{value: 'nome_acompanhante', text: 'Acompanhante', align: 'left'},
                    {value: 'nome_status', text: 'Status', align: 'left'},
                    {value: 'etapaAtual', text: 'Etapa', align: 'left'},
					{text: 'Ações', value: 'action', align: 'center', divider: true}
                ],
                loading: false,
                atendimento: {}

			}
		},
		methods:{
			atualizarAtendimento(atd){
				
				this.atendimento.etapa = atd.etapa
				this.atendimento.etapaAtual = this.verificaEtapa(atd.etapa.toString())
				this.atendimento.status = atd.status.toString()
				this.atendimento.nome_status = atd.nome_status
			},
			finalizarAtendimento(){
				
				this.atendimento.nome_status = 'Concluido'
				this.atendimento.etapaAtual = 'Finalizado'
				
			},
			fechar(){
				this.imprimirAtendimento = false
				this.loading = false
			},


			gerarPdf(item){

				this.atendimento = item
				
				var pdf = new jsPDF('p', 'cm', 'a4')
				var titulo = 'Atendimento nº ' + this.atendimento.id

				pdf.setProperties({
                            title: titulo,
                            subject: 'Assunto',
                            // author: 'me',
							// creator: 'Flyer Builder & jsPDF',

					});

				// fonts initializing
                    pdf.setFont("helvetica");
					pdf.setFontType("bold");
					pdf.setFontSize(16)
					pdf.text(titulo, 10.5, 2, null, null, "center")

					pdf.setFontType("bold");
					pdf.setFontSize(12)
					pdf.text(2, 4, "Nome: ")

					pdf.setFontType("normal");
					pdf.setFontSize(10)
					pdf.text(4, 4, this.atendimento.nome_atendido.toString())

					pdf.setFontType("bold");
					pdf.setFontSize(12)
					pdf.text(2, 4.8, "Responsável: ")

					pdf.setFontType("normal");
					pdf.setFontSize(10)
					pdf.text(5, 4.8, this.atendimento.nome_responsavel.toString())

					pdf.setFontType("bold");
					pdf.setFontSize(12)
					pdf.text(2, 5.6, "Acompanhante: ")

					pdf.setFontType("normal");
					pdf.setFontSize(10)
					pdf.text(5.5, 5.6, this.atendimento.nome_acompanhante.toString())


					pdf.setFontType("bold");
					pdf.setFontSize(12)
					pdf.text(2, 6.4, "Data: ")

					pdf.setFontType("normal");
					pdf.setFontSize(10)
					pdf.text(4, 6.4, this.mostrarData(this.atendimento.data_atendimento.toString()))

					pdf.setFontType("bold");
					pdf.setFontSize(12)
					pdf.text(2, 7.2, "Horário: ")

					pdf.setFontType("normal");
					pdf.setFontSize(10)
					pdf.text(4, 7.2, this.atendimento.hora_atendimento.toString())

					pdf.setFontType("bold");
					pdf.setFontSize(12)
					pdf.text(2, 8, "Status: ")

					pdf.setFontType("normal");
					pdf.setFontSize(10)
					pdf.text(4, 8, this.atendimento.nome_status.toString())

					pdf.setFontType("bold");
					pdf.setFontSize(12)
					pdf.text(2, 8.8, "Considerações finais: ")

					pdf.setFontType("normal");
					pdf.setFontSize(10)
					if(this.atendimento.consideracoes.length > 0){
						pdf.text(7, 8.8, this.atendimento.consideracoes)
					}else{
						pdf.text(7, 8.8, this.atendimento.comentario != null ? this.atendimento.comentario : "")
					}
					

					pdf.setFontType("bold");
					pdf.setFontSize(16)
					pdf.text("Medições", 10.5, 10.6, null, null, "center")

				

				pdf.autoTable({
					// head:[['Chackra', 'Antes', 'Depois']],
					columns:[
						{header: 'Chackra', dataKey: 'chackra'},
						{header: 'Antes', dataKey: 'antes'},
						{header: 'Depois', dataKey: 'depois'}
					],
					body:[
						{chackra: 'Raiz', antes: this.mostrarDescricaoMedicao(this.atendimento.raiz_antes), depois: this.mostrarDescricaoMedicao(this.atendimento.raiz_depois)},
						{chackra: 'Sexual', antes: this.mostrarDescricaoMedicao(this.atendimento.sexual_antes), depois: this.mostrarDescricaoMedicao(this.atendimento.sexual_depois)},
						{chackra: 'Solar', antes: this.mostrarDescricaoMedicao(this.atendimento.solar_antes), depois: this.mostrarDescricaoMedicao(this.atendimento.solar_depois)},
						{chackra: 'Cardiaco', antes: this.mostrarDescricaoMedicao(this.atendimento.cardiaco_antes), depois: this.mostrarDescricaoMedicao(this.atendimento.cardiaco_depois)},
						{chackra: 'Laringeo', antes: this.mostrarDescricaoMedicao(this.atendimento.laringeo_antes), depois: this.mostrarDescricaoMedicao(this.atendimento.laringeo_depois)},
						{chackra: 'Frontal', antes: this.mostrarDescricaoMedicao(this.atendimento.frontal_antes), depois: this.mostrarDescricaoMedicao(this.atendimento.frontal_depois)},
						{chackra: 'Coronario', antes: this.mostrarDescricaoMedicao(this.atendimento.coronario_antes), depois: this.mostrarDescricaoMedicao(this.atendimento.coronario_depois)},
						{chackra: 'Kundalini', antes: this.mostrarDescricaoMedicao(this.atendimento.kundalini_antes), depois: this.mostrarDescricaoMedicao(this.atendimento.kundalini_depois)}
					],
					margin: {top: 11}
				})
				pdf.setFillColor(100, 100, 240);
				pdf.setDrawColor(100, 100, 0);
				pdf.setLineWidth(1);
				pdf.rect(50, 100, 10, 10, 'FD');


				//this.$refs.relPdf.$el.attr('src', pdf.output('datauristring'));
				this.imprimirAtendimento = true
				let that = this
				setTimeout(() => {
					that.$refs.relPdf.src = pdf.output('datauristring')
				}, 2000)
			},

			

			buscaFichas(){
				this.loading = true
				const url = `${baseApiUrl}/Atendimentos/Fichas/read.php`

				axios.get(url)
						.then(res => {

							this.fichas = res.data.map(f => {
                                return{
                                    ...f,
                                    etapaAtual: this.verificaEtapa(f.etapa),
                                    camposAtendimento: f.campo_atuacao.split(","),
                                    motivos: f.motivo.split(",")
                                }
							})
							
						this.totalPaginas = Math.ceil(this.fichas.length / this.itensPorPagina)
						this.loading = false
						})
						.catch({showError})
            },

            verificaEtapa(etapa){
                let nomeEtapa = ""
                switch(etapa){
                    case '3':
                        break;
                    case '4':
                    nomeEtapa = 'Aguardando confirmação'
                        break;
                    case '5':
                    nomeEtapa = 'Registrar resultados'
                        break;
                    case '6':
					nomeEtapa = "Finalizado"
                        break;
                    case '7':
                    nomeEtapa = "Finalizado"
                        break;
				}
                return nomeEtapa
            },

            cadastrarNovaFicha(){
                this.ficha = {},
                this.abrirNovaFicha = true
             },

             fecharAtendimento(){
                this.abrirEdicao = false
                this.ficha = {}
                this.atendimento = {}
             },

			 editar(ficha){
				this.atendimento = ficha
                // this.pessoa.signo = this.retornaSigno(this.pessoa.dataNascimentoObj)
                // this.pessoa.desafio = this.retornaDesafio(this.pessoa.dataNascimentoObj)
                this.abrirEdicao = true
            },

			// atualizarLista(pessoa){
			// 	this.pessoas.push(pessoa)
			// },

			// excluir(pessoa){
			// 	this.pessoa = pessoa
			// 	this.abrirExclusaoPessoa = true
			// },

			// atualizarExclusao(pessoa){
			// 	this.abrirExclusaoPessoa = false
			// 	let idx = this.pessoas.findIndex((v) => {
			// 		return v.id == pessoa.id
			// 	})

			// 	this.pessoas.splice(idx)

			// },
		},

		created(){
			this.buscaFichas()
		}
	}
</script>

<style scoped>
iframe, .no_iframe {
		width:100%;
		height:400px;
		border:1px solid #666;
		background-color: #ddd;
	}

</style>